import { FetchHttpClient } from "@effect/platform"
import { OpenRevenueApi } from "@open-revenue/api/schema"
import { createRuntimeContext, makeObject } from "@open-revenue/effect-react-query"
import { Api as DashApi } from "@superwall/api/dash-api/schema"
import { Layer } from "effect"
import { DashApiClient, DashApiClientLive, OpenRevenueClient } from "./client"
import { browserLogger } from "./utils"

export const MainLayer = Layer.mergeAll(
  browserLogger,
  FetchHttpClient.layer,
  DashApiClientLive,
  OpenRevenueClient.Live.pipe(Layer.provide(FetchHttpClient.layer))
)
export const AppRuntime = createRuntimeContext(MainLayer)

export const dashApi = makeObject(DashApi, AppRuntime, DashApiClient)
export const openRevenueApi = makeObject(OpenRevenueApi, AppRuntime, OpenRevenueClient)
